import { apiClient } from '../api/client';

export interface GameLinkStatus {
  linked: boolean;
  linkedAt: string | null;
  nick: string;
  /** O /vincular e o /resgatar com o nome que o lojista deu no painel. */
  command?: string;
  redeemCommand?: string;
}

export interface GameLinkCode {
  code: string;
  expiresAt: string;
  nick: string;
  command?: string;
  redeemCommand?: string;
}

/** Vínculo da conta com o jogador no servidor (/vincular), só do jogador logado. */
export const gameLinkService = {
  async status(storeId: string): Promise<GameLinkStatus> {
    return apiClient.get<GameLinkStatus>(`/public/stores/${storeId}/players/me/game-link`);
  },
  async gerarCodigo(storeId: string): Promise<GameLinkCode> {
    return apiClient.post<GameLinkCode>(`/public/stores/${storeId}/players/me/game-link`, {});
  },
  async desvincular(storeId: string): Promise<GameLinkStatus> {
    return apiClient.delete<GameLinkStatus>(`/public/stores/${storeId}/players/me/game-link`);
  },
};
